import { createSelector } from '@reduxjs/toolkit';
import User from 'gql/User';
import { ActionStatus } from 'store/ActionState';
import { RootState } from 'store/RootReducer';
import { Notification, UserState } from 'components/app/store/UserSlice';

const selectSelf = (state: RootState): UserState => state.user;

const selectUser = createSelector(selectSelf, (state: UserState): User | undefined => state.user);

const selectIsLoadingUser = createSelector(selectSelf, (state: UserState): boolean => {
  return (
    state.userState.status === ActionStatus.PROCESSING ||
    (state.userState.status === ActionStatus.IDLE && !state.signOut)
  );
});

const selectNotification = createSelector(
  selectSelf,
  (state: UserState): Notification | undefined => state.notification
);

const UserSelectors = {
  selectUser,
  selectIsLoadingUser,
  selectNotification,
};

export default UserSelectors;
